import MuiTableContainer, { TableContainerProps } from '@mui/material/TableContainer';
import { FC } from 'react';

const TableContainer: FC<TableContainerProps> = (props) => (
  <MuiTableContainer
    { ...props }
    sx={
      {
        ...props.sx as object,
        overflow: 'visible',
      }
    }
  />
);

export default TableContainer;
